module.exports = __webpack_public_path__ + "static/media/VAR-BASIS.52e0efa5.apng";